import { createApiRef } from "@backstage/core-plugin-api";
import type { IncidentClient } from "@internal/backstage-plugin-incidentio-common";

/**
 * ApiRef for the incident.io plugin client.
 *
 * Typed by the class in `incidentio-common` but importing only the type, so the
 * factory that constructs it stays in the app-facing `incidentio` package and
 * this one keeps no runtime dependency on the client.
 *
 * @public
 */
export const incidentApiRef = createApiRef<IncidentClient>({
    id: "plugin.incidentio.service",
});
